import React from 'react'
import { connect } from 'react-redux'
import { ControlLabel, FormControl, Button, Checkbox } from 'react-bootstrap'

import { loginUser } from '../reducers/manageLogin'

class LoginForm extends React.Component {

  state = {
    username: localStorage.getItem("rememberMe") || "",
    password: "",
    error: "",
    rememberMe: !!localStorage.getItem("rememberMe")
  }

    /// INPUT FUNCTIONS BEGIN
  handleUsernameInput = (e) => {
    this.setState({
      username: e.target.value
    })
  }

  handlePasswordInput = (e) => {
    this.setState({
      password: e.target.value
    })
  }

  handleKeyPress = (e) => {
    if(e.key === "Enter"){
      this.handleLogin()
    }
  }
  /// INPUT FUNCTIONS END

  handleLogin = () => {
    /// USE THE 2 LINES BELOW IF YOU CAN'T LOG IN THROUGH THE DEV SERVER
    /// JUST COMMENT OUT THE WHOLE IF/ELSE STATEMENT
    // localStorage.setItem("token","valid_token")
    // this.props.history.push("/");

    if (this.state.username && this.state.password) {
      this.setState({error: ""}, () => {
        this.props.loginUser(this.state.username,
                             this.state.password,
                             this.props.history,
                             this.state.rememberMe)
      })
    } else {
      if (!this.state.username && !this.state.password) {
        this.setState({error: "Please input your username and password"})
      }
      else if(!this.state.username) {this.setState({error: "Please input your username"})}
      else if(!this.state.password) {this.setState({error: "Please input your password"})}
    }
  }

  handleLoginWithSSO = () => {
    const SSOURL = `${process.env.REACT_APP_SSO_URL}`
    if (process.env.REACT_APP_MODE === "DEV") {
      window.location = `http://localhost${SSOURL}`
      return
    }
    window.location = `${process.env.REACT_APP_URL_PREFIX}${window.location.host.split(".")[0]}${SSOURL}`
  }

  render () {
    return(
      <div id="LoginForm">
        <div id="error-field">
          { this.state.error }
        </div>
        { (["DEV"].includes(process.env.REACT_APP_MODE)) &&
          <React.Fragment>
            <div id="username-field">
              <ControlLabel>Username or email</ControlLabel>
              <FormControl
                label="Username or email"
                placeholder="Enter username or email"
                value={ this.state.username }
                onChange={ this.handleUsernameInput }
                onKeyPress={ this.handleKeyPress }
              />
              <Checkbox
                inline
                checked={ this.state.rememberMe }
                onChange={ () => this.setState({ rememberMe: !this.state.rememberMe }) }
              >
                Remember Username
              </Checkbox>
            </div>
            <br/>
            <div id="password-field" data-private>
              <ControlLabel>Password</ControlLabel>
              <FormControl
                type="password"
                label="Password"
                placeholder="Enter password"
                onChange={ this.handlePasswordInput }
                onKeyPress={ this.handleKeyPress }
              />
            </div>
            <div id="login-button">
              <Button onClick={ this.handleLogin }>Log In</Button>
            </div>
            <br/>
          </React.Fragment>
        }
        <div id="login-button">
          <img
            onClick={ this.handleLoginWithSSO }
            style={{ cursor: "pointer" }}
            src={ require("../../../static/images/ms-symbollockup_signin_light.svg") }
            alt="Sign in with Microsoft"
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticating: state.manageLogin.isAuthenticating
  }
}

export default connect(mapStateToProps, { loginUser })(LoginForm);



// WEBPACK FOOTER //
// ./src/routes/login/components/LoginForm.js